import React, { useState } from 'react';
import PropTypes from 'prop-types';
import InsightRow from './InsightRow';
import SuggestionsSection from './SuggestionsSection';
import css from './InsightsList.css';
import { CategoryOrder } from '../consts';
import BriefGeneratorButton from './BriefGeneratorButton';
import BriefShelf from './BriefShelf';
import { Shelf } from '../../../../components/widgets';

const InsightsList = ({ allInsights, suggestions, expandedCategory, onCategoryClick, briefs }) => {
    const [openBriefShelf, setOpenBriefShelf] = useState(false);
    if (!allInsights) return null;

    return (
        <>
            <div className={css.insightHeader}>
                <span className={css.greeting}>Get your insights</span>
                <BriefGeneratorButton onBriefGenerator={() => setOpenBriefShelf(true)} />
            </div>
            <div className={css.rowsWrapper}>
                {Object.entries(allInsights)
                    .sort((a, b) => {
                        const [titleA] = a;
                        const [titleB] = b;
                        const indexA = CategoryOrder.indexOf(titleA);
                        const indexB = CategoryOrder.indexOf(titleB);
                        return indexA - indexB;
                    })
                    .map(([category, data], index) => (
                        <InsightRow
                            key={`insight-${category}`}
                            category={category}
                            data={data}
                            insightIndex={index}
                            expandedCategory={expandedCategory}
                            onCategoryClick={onCategoryClick}
                        />
                    ))}
                <SuggestionsSection
                    suggestions={suggestions}
                    expandedCategory={expandedCategory}
                    onCategoryClick={onCategoryClick}
                />
            </div>
            {openBriefShelf && (
                <Shelf
                    open={openBriefShelf}
                    onClose={() => setOpenBriefShelf(false)}
                    headerText="STATIC.PAGES.CREATIVE_INSIGHTS.BRIEFS"
                    headerIconName="pencil-2-ai-line"
                    shelfSize="xxlarge"
                    enterAnimationDisabled={false}
                    contentContainerClass={css.shelfContainer}
                >
                    <BriefShelf briefs={briefs} />
                </Shelf>
            )}
        </>
    );
};

InsightsList.propTypes = {
    allInsights: PropTypes.object,
    suggestions: PropTypes.array,
    expandedCategory: PropTypes.string,
    onCategoryClick: PropTypes.func.isRequired,
    briefs: PropTypes.object,
};

export default InsightsList;
